export default {
  backToTop: 'Back to top',
};



// WEBPACK FOOTER //
// ./src/config/locales/en/footer.js